import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { CompareIndex } from "../components/compare/CompareIndex";
import { compareIndexHead, compareIndexPath } from "../lib/compare/head";
import { loadCompareCopy } from "../lib/compare/index";
import { COMPARE_UI } from "../lib/compare/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** The comparison hub in a non-English language, at `/<lang>/compare`. */
export const Route = createFileRoute("/$lang/compare/")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = compareIndexPath(lang);
    if (path !== `/${params.lang}/compare`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, copy: await loadCompareCopy(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? compareIndexHead(
          loaderData.lang,
          COMPARE_UI[loaderData.lang],
          loaderData.copy,
        )
      : {},
  component: LocalizedCompareIndex,
});

function LocalizedCompareIndex() {
  const { lang, copy } = Route.useLoaderData();
  return <CompareIndex lang={lang} ui={COMPARE_UI[lang]} copy={copy} />;
}
